import type { ReactNode} from 'react'
import { createContext, useContext } from 'react'

import type { LogoutTimerState} from '@/hooks/useLogoutTimer'
import { useLogoutTimer } from '@/hooks/useLogoutTimer'

const logoutTimerContext = createContext<LogoutTimerState>({} as LogoutTimerState)

export const LogoutTimerProvider = ({ children }: { children: ReactNode }) => {
  const logoutTimer = useLogoutTimer()

  return <logoutTimerContext.Provider value={logoutTimer}>
    {children}
  </logoutTimerContext.Provider>
}

export const useLogoutTimerContext = () => {
  const ctx = useContext(logoutTimerContext)
  if (!ctx)
    throw new Error('useLogoutTimerContext must be used within a LogoutTimerProvider!')

  return ctx
}